
































import Vue, { PropType } from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import MainNavigationItem from '@/webcomponents/header/MainNavigationItem.vue';
import SubNavigation from '@/webcomponents/header/components/SubNavigation.vue';
import SubNavigationItem from '@/webcomponents/header/SubNavigationItem.vue';
import CustomButton from '@/common/vue/CustomButton.vue';
import HeaderFlyoutContent from '@/webcomponents/header/components/HeaderFlyoutContent.vue';

const HeaderFlyoutProps = Vue.extend({
  props: {
    navItem: Object as PropType<MainNavigationItem>,
  },
});

@Component({
  components: {
    CustomButton,
    HeaderFlyoutContent,
    SubNavigation,
  },
})
export default class HeaderFlyout extends HeaderFlyoutProps {
  $refs!: {
    subNavigation: SubNavigation;
  }

  openMenu: MainNavigationItem | null = null;
  subNavItem: SubNavigationItem | null = null;
  fadeIn = false;
  fadeOut = false;
  switchMenu = false;
  switchSubnav = false;
  flyoutContent: string | null = null;
  itemHover = false;
  itemHoverLeave = false;

  @Watch('navItem')
  changeMenu (newMenu: MainNavigationItem): void {
    this.switchMenu = true;
    this.fadeIn = false;
    this.fadeOut = true;

    let nextMenuContent: string | null = null;
    let fadedOutDone = false;

    this.loadMenuContent(newMenu).then((data: string) => {
      nextMenuContent = data;
      if (fadedOutDone) {
        this.completeChange(newMenu, nextMenuContent);
      }
    });
    setTimeout(() => {
      fadedOutDone = true;
      if (nextMenuContent) {
        this.completeChange(newMenu, nextMenuContent);
      }
    }, 400);
  }

  closeSubMenu () {
    const { openMenu } = this;
    if (this.subNavItem && openMenu) {
      this.switchMenu = true;
      this.switchSubnav = true;
      this.fadeIn = false;
      this.fadeOut = true;

      let nextMenuContent: string | null = null;
      let fadedOutDone = false;

      this.loadMenuContent(openMenu).then((data: string) => {
        nextMenuContent = data;
        if (fadedOutDone) {
          this.completeChange(openMenu, nextMenuContent);
        }
      });
      setTimeout(() => {
        fadedOutDone = true;
        if (nextMenuContent) {
          this.completeChange(openMenu, nextMenuContent);
        }
      }, 400);
    }
  }

  completeChange (newMenu: MainNavigationItem, nextMenuContent: string): void {
    this.openMenu = newMenu;
    this.subNavItem = null;
    this.displayMenuContent(nextMenuContent);
    this.switchMenu = false;
    this.fadeOut = false;
    setTimeout(() => {
      this.fadeIn = true;
    }, 25);
  }

  changeSubNav (newMenu: SubNavigationItem): void {
    if (this.subNavItem !== newMenu) {
      this.switchMenu = true;
      this.switchSubnav = true;
      this.fadeIn = false;
      this.fadeOut = true;

      let nextMenuContent: string | null = null;
      let fadedOutDone = false;

      this.loadMenuContent(newMenu).then((data: string) => {
        nextMenuContent = data;
        if (fadedOutDone) {
          this.completeSubNavChange(newMenu, nextMenuContent);
        }
      });
      setTimeout(() => {
        fadedOutDone = true;
        if (nextMenuContent) {
          this.completeSubNavChange(newMenu, nextMenuContent);
        }
      }, 400);
    }
  }

  completeSubNavChange (newMenu: SubNavigationItem, nextMenuContent: string): void {
    this.subNavItem = newMenu;
    this.displayMenuContent(nextMenuContent);
    this.switchSubnav = false;
    this.switchMenu = false;
    this.fadeOut = false;
    setTimeout(() => {
      this.fadeIn = true;
    }, 25);
  }

  closeOverlay (): void {
    this.fadeIn = false;
    this.fadeOut = true;
    this.subNavItem = null;
  }

  handleTransitionEnd (): void {
    if (this.fadeOut && !this.switchMenu) {
      this.fadeOut = false;
      this.$emit('on-menu-close');
    }
  }

  loadMenuContent (openMenu: MainNavigationItem | SubNavigationItem) {
    return new Promise<string>(((resolve, reject) => {
      if (openMenu) {
        fetch(openMenu.flyoutUrl)
          .then((response) => response.text())
          .then((data) => resolve(data));
      } else {
        reject();
      }
    }));
  }

  displayMenuContent (data: string) {
    const html = new DOMParser().parseFromString(data, 'text/html');
    this.flyoutContent = html.querySelector('.headerflyout')?.innerHTML || null;
    setTimeout(() => {
      this.fadeIn = true;
    }, 25);
  }

  handleItemHover (evt: any): void {
    if (evt as CustomEvent && evt.detail) {
      if (evt.detail.mouseEnter) {
        this.itemHover = true;
      } else {
        this.itemHover = false;
        this.itemHoverLeave = true;
        setTimeout(() => {
          this.itemHoverLeave = false;
        }, 500);
      }
    }
  }

  onContentEndFocus () {
    this.$refs.subNavigation.$refs.closeButton.focus();
  }

  get rootClass () {
    return {
      'brandhub-header-flyout--in': this.fadeIn,
      'brandhub-header-flyout--out': this.fadeOut,
      'brandhub-header-flyout--switch': this.switchMenu,
      'brandhub-header-flyout--switch-subnav': this.switchSubnav,
      'brandhub-header-flyout--item-hover': this.itemHover,
      'brandhub-header-flyout--item-hover-leave': this.itemHoverLeave,
    };
  }

  get exploreText (): string {
    if (this.subNavItem) {
      return this.subNavItem.itemText;
    }

    return this.openMenu
      ? this.openMenu.itemText
      : this.navItem.itemText;
  }

  created (): void {
    this.openMenu = this.navItem;
    this.loadMenuContent(this.openMenu).then(this.displayMenuContent);
  }

  mounted (): void {
    this.$el.addEventListener('flyout-item-hover', this.handleItemHover);
  }
}
